import React from "react"
import { Tabs, Tab, TabsProps, TabProps } from "@mui/material"
import styled from "styled-components"
import { down } from "styled-breakpoints"
import colors from "@constants/colors"

export const StyledTabsContainer = styled(Tabs)`
  && {
    min-height: 0;
    position: relative;
    margin-bottom: 10px;
  }

  &&::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: ${colors.red};
    z-index: 0;
  }

  &.MuiTabs-root {
    min-height: 0;
  }

  .MuiTabs-indicator {
    display: none;
  }

  .MuiTabs-flexContainer {
    gap: 0;
    flex-wrap: nowrap;
    position: relative;
    z-index: 1;

    ${down("mobile")} {
      width: 100%;
    }
  }
`

export const StyledTab = styled(Tab)`
  && {
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.65);
    padding: 8px 16px;
    margin-right: 2px;
    min-height: auto;
    min-width: auto;
    text-align: left;
    align-items: flex-start;
    opacity: 1;
    position: relative;
    z-index: 1;
    white-space: nowrap;
    flex-shrink: 0;
    letter-spacing: 0;
    background: #fafafa;
    border-radius: 3px 3px 0 0;
    border: 1px solid #d9d9d9;
    border-bottom: none;
    margin-bottom: 1px;
    transition: all 0.2s;
  }

  ${down("tablet")} {
    && {
      font-size: 16px;
      margin-right: 2px;
      padding: 8px 16px;
      width: auto;
      flex: 0 0 auto;
      min-width: auto;
      max-width: none;
    }
  }

  ${down("mobile")} {
    && {
      font-size: 14px;
      margin-right: 2px;
      padding: 6px 12px;
      width: auto !important;
      flex: 0 0 auto !important;
      min-width: auto !important;
      max-width: none !important;
    }
  }

  &&.Mui-selected {
    color: ${colors.red};
    background: #ffffff;
    border: 1px solid ${colors.red};
    border-bottom: none;
    margin-bottom: 0;
    z-index: 2;
  }

  &&:hover:not(.Mui-selected) {
    color: ${colors.red};
  }

  .MuiTab-wrapper {
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    font-weight: 500;
  }

  span {
    white-space: nowrap;
    display: inline;
    font-weight: 500;
  }
`

export const TabsWithBorder: React.FC<TabsProps> = (props) => {
  return <StyledTabsContainer {...props} />
}

export const TabWithBorder: React.FC<TabProps> = (props) => {
  return <StyledTab {...props} />
}
